import React from 'react'
import { ListGroup, ListGroupItem } from 'react-bootstrap'

export function Link({ target, text }) {
  return (
    <ListGroup className="m-0">
      <ListGroupItem
        href={target}
        rel="noreferrer"
        target='_blank'
        className="btn btn-myed btn-default btn-default-myed btn-sm-myed p-2 d-inline-flex align-items-center"
      >
        <p className="my-0 py-0 d-inline text-primary">{text}</p>
        <i
          className="my-0 py-0 pl-1 pt-1 fas fa-arrow-right text-primary"
          style={{ transform: 'rotate(-45deg)' }}
        ></i>
      </ListGroupItem>
    </ListGroup>
  )
}
